import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Link } from '@superops/ui-design-system';
import React from 'react';
import dompurify from 'dompurify';
import { Tooltip } from 'react-clone-tippy';
import { dompurifier } from '@nile/components/src/Utils/helpers';

function HTMLCell(props) {
  const { cell, action } = props;
  const actions = cell.column.actions;
  const value = props.column.subAccessor
    ? cell.value[props.column.subAccessor]
    : cell.value;
  const allProps = {
    ...cell,
    ticketId: cell.row.original.ticketId,
    module: 'TICKET',
    data: {
      subject: cell?.row?.original?.subject,
      displayId: cell?.row?.original?.displayId,
      ticketId: cell?.row?.original?.ticketId
    }
  };
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <CellWrapper id={value}>
      <Tooltip
        title={dompurifier(value)}
        delay={300}
        duration={250}
        position="bottom-start"
        inertia
        trigger="mouseenter"
        animation="shift"
        animateFill={false}
      >
        {cell?.column?.isTrashView ? (
          <div className="ellipsis">{value}</div>
        ) : (
          <Link onClick={actions.onClick.bind(this, allProps)} removeUnderline>
            <div className="ellipsis">{value}</div>
          </Link>
        )}
      </Tooltip>
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default HTMLCell;
